import Modal from 'src/components/Modal'
import React, { useState } from 'react'
import * as S from './styles'

export const ModalInvoicePrint = ({ cancelAction, invoiceUrls }) => {
  const [index, setIndex] = useState(0)

  const printNext = () => {
    window.open(invoiceUrls[index], '_blank')
    const newIndex = index + 1

    if (newIndex >= invoiceUrls.length) {
      cancelAction()
      setIndex(0)
    } else {
      setIndex(newIndex)
    }
  }

  if (invoiceUrls.length === 0) {
    return <></>
  }

  return (
    <Modal
      show={invoiceUrls.length > 0}
      title={`Imprimir notas fiscais`}
      closeButtonAction={cancelAction}
      body={
        <S.Wrapper>
          <S.Text>
            {index + 1} / {invoiceUrls.length}
          </S.Text>

          <S.PrintButton onClick={printNext}>Imprimir Próximo</S.PrintButton>
        </S.Wrapper>
      }
    />
  )
}
